/**
 * Returns the user's locale from the browser's Navigator object
 * @returns locale, string
 */
export default function (): string {
  if (navigator.languages?.length) {
    return navigator.languages[0];
  } else {
    return navigator.language || 'en';
  }
}
